import { environment } from '../../../environments/environment';
import { getIsSiriusEnabled } from '../sirius-util';

export function getSecuritySettingsUrl(): string {
  return `${
    environment.apps.presence
  }/provider-profile/security-settings?use-sirius=${
    getIsSiriusEnabled() ? 1 : 0
  }`;
}
